import ChatConfig from "@/Modules/Chat/Config";

import { useUserStore } from "@/Modules/User/Store";
import { useActivityCenterStore } from "@/Modules/ActivityCenter/Store";
import { useChatStore } from "../Store";

import { hasValue } from "@/Utils/Objects";
import { isValidString } from "@/Utils/String";
import { isApp } from "@/Utils/Ionic";
import useAppStore from "@/Modules/App/Store";

export enum SetActiveChatReturn {
  INVALID_CHAT = "INVALID_CHAT",
  ERROR = "ERROR",
  FETCH = "FETCH",
  NOTHING = "NOTHING",
}

const setActiveChatRoomActionHandler = async (chatRoomId?: string): Promise<SetActiveChatReturn> => {
  const chatStore = useChatStore();
  const appStore = useAppStore();
  const userStore = useUserStore();
  const activityCenterStore = useActivityCenterStore();
  let isFetch = false;

  try {
    if (!isValidString(chatRoomId)) {
      chatStore.activeChatRoomId = undefined;
      appStore.showNavigation();

      return SetActiveChatReturn.INVALID_CHAT;
    }

    if (!hasValue(chatStore.rooms[chatRoomId])) {
      return SetActiveChatReturn.INVALID_CHAT;
    }

    if (!hasValue(chatStore.rooms[chatRoomId].events)) {
      chatStore.rooms[chatRoomId].events = [];
    }

    if (chatRoomId !== chatStore.activeChatRoomId) {
      let numUnreadEvents = Math.floor(chatStore.rooms[chatRoomId].unreadEvents); // Clone remove references
      const CHAT_SIZE = isApp() ? ChatConfig.CHAT_EVENT_PAGE_SIZE_APP : ChatConfig.CHAT_EVENT_PAGE_SIZE;

      chatStore.activeChatRoomId = chatRoomId;
      chatStore.rooms[chatRoomId].unreadEvents = 0; // Important not move. Prevent duplicated fetchs

      if (userStore.getUserIsTherapist) {
        if (chatStore.rooms[chatRoomId].unreadEvents > 0) {
          // Update after fetch user this can be removed with the await of loadhatRoomUser if the notification toolbar is absolute
          numUnreadEvents += chatStore.rooms[chatRoomId].unreadEvents;
        }
      }

      if (numUnreadEvents > 0 || chatStore.rooms[chatRoomId].events.length === 0) {
        chatStore.rooms[chatRoomId].isLoadingEvents = true;
        isFetch = true;

        chatStore.getChatMessages(chatRoomId, numUnreadEvents);
      } else if (chatStore.rooms[chatRoomId].events.length < CHAT_SIZE) {
        chatStore.rooms[chatRoomId].events = [];
        chatStore.rooms[chatRoomId].isLoadingEvents = true;
        isFetch = true;

        chatStore.getChatMessages(chatRoomId, 0);

        chatStore.rooms[chatRoomId].isLoadingEvents = false;
      }
    }

    chatStore.rooms[chatRoomId].unreadEvents = 0;
    chatStore.rooms[chatRoomId].numberNotifications = 0;

    activityCenterStore.getNumberOfNewNotifications(chatStore.rooms[chatRoomId].user.id, chatRoomId);
    chatStore.loadChatRoomUser(chatRoomId);
    appStore.hideNavigation();

    if (isFetch) return SetActiveChatReturn.FETCH;

    chatStore.rooms[chatRoomId].isLoadingEvents = false;

    return SetActiveChatReturn.NOTHING;
  } catch (e) {
    return SetActiveChatReturn.ERROR;
  }
};

export default setActiveChatRoomActionHandler;
